import React from "react";

const HrLine = () => {
  return <br />;
}

export default HrLine;